// import { Modal } from "@mui/material";
import { Box, Modal, Slider, Typography } from '@mui/material';
import { CalculateIcon, CloseIcon, Flex, IconButton, Button, Image, Input, Link, Text } from '@pancakeswap/uikit';
import Balance from 'components/Balance';
import React, { useState, FC, useEffect } from 'react';
import styled from 'styled-components';
import headerimage from '../../../../assets/images/headerimage.png'
import RoiCalculatorModal from './RoiCalculatorModal';
import { ethers, BigNumber } from "ethers";
import { getLockUpAddress, getTokenAddress } from "utils/addressHelpers";
import { getContract } from "utils/contractHelpers";
import DrivenStakingABI from "ABI/DrivenStakingABI.json";
import DrivenLockupABI from "ABI/DrivenLockupABI.json";
import UniRouterABI from "ABI/UniRouterABI.json";
import { useWeb3React } from '@web3-react/core';
import { useDispatch, useSelector } from 'react-redux';
import { setPidx } from 'store/IndexSlice';
import LoopIcon from '@mui/icons-material/Loop';



interface StakeModalProps {
    onClose: () => void;
    open: boolean;
    isRemovingStake?: boolean
    pool?: any
    stack?: string
}



const ModalHeader = styled(Box)`
    align-items: center;
    background: #00202F;
    // border-bottom: 1px solid #00FED9;
    display: flex;
    padding: 24px 24px;
    border-top-left-radius: 32px;
    border-top-right-radius: 32px;

`

const ModalHeaderText = styled(Box)`
    align-items: center;
    flex: 1 1 0%;
    display: flex;
    justify-content: space-between;
`

const ModalBody = styled(Box)`
    flex-direction: column;
    max-height: 90vh;
    overflow-y: auto;
    display: flex;
    padding: 24px;
`

const StyledBalanceInput = styled(Box)`
    background-color: #1A3342;
    border: 1px solid #00FED9;
    border-radius: 16px;
    box-shadow: ${({ theme }) => theme.shadows["inset"]};
    padding: 8px 16px;
`;

const StyledInput = styled(Input) <{ textAlign?: string }>`
  background: transparent;
  border-radius: 0;
  color : white;
  box-shadow: none;
  padding-left: 0;
  padding-right: 0;
  /* margin-top: 10px; */
  text-align: ${({ textAlign = "right" }) => textAlign};
  border: none;

  ::placeholder {
    color: #B1B3CB;
  }

  &:focus:not(:disabled) {
    box-shadow: none;
  }
`;

const UnitContainer = styled(Text)`
    margin-left: 4px;
    text-align: right;
    color: ${({ theme }) => theme.colors.textSubtle};
    white-space: nowrap;
`;

const PercentageButton = styled(Box)`
    flex-grow: 1;
    align-items: center;
    border: 0px none;
    border-radius: 16px;
    cursor: pointer;
    display: inline-flex;
    font-family: inherit;
    font-weight: 600;
    -moz-box-pack: center;
    justify-content: center;
    letter-spacing: 0.03em;
    line-height: 1;
    opacity: 1;
    outline: currentcolor none 0px;
    transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s;
    height: 20px;
    font-size: 12px;
    background-color: #00FED9;
    box-shadow: none;
    color: rgb(15, 33, 49);
    padding: 4px 16px;
    margin-right: 2px;
    margin-left: 2px;
`
const AnnualRoiContainer = styled(Flex)`
  cursor: pointer;
`
const AnnualRoiDisplay = styled(Text)`
  width: 72px;
  max-width: 72px;
  overflow: hidden;
  text-align: right;
  text-overflow: ellipsis;
`

const StyledLink = styled(Link)`
  width: 100%;
`

const ConfirmButton = styled(Button)`
    align-items: center;
    border: 0px none;
    border-radius: 16px !important;
    box-shadow: rgba(14, 14, 44, 0.4) 0px -1px 0px 0px inset !important;
    cursor: pointer;
    display: inline-flex;
    font-family: inherit;
    font-size: 16px;
    font-weight: 600;
    -moz-box-pack: center;
    justify-content: center;
    letter-spacing: 0.03em;
    line-height: 1;
    opacity: 1;
    outline: currentcolor none 0px;
    transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s !important;
    height: 48px;
    padding: 0px 24px;
    background-color: #00FED9 ;
    color: black;
    margin-top: 24px;
`
const GetSymbol = styled(Button)`
    align-items: center;
    border-radius: 16px !important;
    cursor: pointer;
    display: inline-flex;
    font-family: inherit;
    font-size: 16px;
    font-weight: 600;
    -moz-box-pack: center;
    justify-content: center;
    letter-spacing: 0.03em;
    line-height: 1;
    opacity: 1;
    outline: currentcolor none 0px;
    transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s !important;
    height: 48px;
    padding: 0px 24px;
    background-color: transparent;
    border: 2px solid #00FED9 !important;
    box-shadow: none;
    color: white !important;
    width: 100%;
    margin-top: 8px !important;
`

const StakeModal: React.FunctionComponent<StakeModalProps> = ({
    open,
    onClose,
    pool,
    stack,
    isRemovingStake = false

}) => {

    const { error, connector, activate, deactivate, library, active, account } = useWeb3React();
    const [RoiCalculatoropen, setRoiCalculatorOpen] = React.useState(false);
    const [stackvalue, setStakeValue] = useState("");
    const [usdvalue, setUSDvalue] = useState(0);
    const [disabledbutton, setDisabledButton] = useState(false);
    const [percentage, setPercentage] = useState(0);
    const RoiCalculator = () => setRoiCalculatorOpen(true);
    const handleClose = () => setRoiCalculatorOpen(false);
    const lockupAddress = getLockUpAddress();
    const tokenAddress = getTokenAddress();
    const pidx = useSelector((state: any) => state.Index.processidx)
    const dispatch = useDispatch()


    // useEffect(() => {
    //     if (account) {
    //         const fetchInfo = async () => {
    //             const lockUpContract = getContract(DrivenLockupABI, lockupAddress);
    //             let routeAddress = await lockUpContract.uniRouterAddress();
    //             const routerContract = getContract(UniRouterABI, routeAddress);
    //             if (stackvalue !== "0" && stackvalue) {

    //                 const routerOut = await routerContract.getAmountsOut(ethers.utils.parseEther(stackvalue), [tokenAddress, "0xae13d989dac2f0debff460ac112a837c89baa7cd", "0x78867BbEeF44f2326bF8DDd1941a4439382EF2A7", "0x7ef95a0FEE0Dd31b22626fA2e10Ee6A223F8a684"]);
    //                 setUSDvalue(parseFloat(ethers.utils.formatEther((routerOut[3]).toString())))
    //             } else {
    //                 setUSDvalue(0);
    //             }
    //         }
    //         fetchInfo();
    //     }
    // }, [account, stackvalue]);
    const USDCalculation = async () => {
        const fetchInfo = async () => {
            if (stackvalue !== "0" && stackvalue) {
                debugger;
                console.log(pool.tokenUsdprice)
                setUSDvalue(parseFloat(stackvalue) * pool.tokenUsdprice)
            } else {
                setUSDvalue(0);
            }
        }
        fetchInfo();

    }
    useEffect(() => {
        USDCalculation();
    }, [stackvalue]);

    const depositDVX = async () => {
        setDisabledButton(true);

        try {
            let tx;
            if (pool.contractType == "lockup") {
                const lockupContract = getContract(DrivenLockupABI, lockupAddress, library.getSigner());
                tx = await lockupContract.deposit(ethers.utils.parseEther(stackvalue), pool.stackType);
            }
            await tx.wait();
            dispatch(setPidx(pidx + 1))
            onClose();
        } catch (err) {
            console.log(err);
        }
        setDisabledButton(false);

    }
    const unStackDVX = async () => {
        setDisabledButton(true);

        try {
            let tx;
            if (pool.contractType == "lockup") {
                const lockupContract = getContract(DrivenLockupABI, lockupAddress, library.getSigner());
                tx = await lockupContract.withdraw(ethers.utils.parseEther(stackvalue), pool.stackType);
            }
            await tx.wait();
            dispatch(setPidx(pidx + 1))
            onClose();
        } catch (err) {
            console.log(err);
        }
        setDisabledButton(false);

    }
    const setPercentValue = (per) => {
        let bignumx = BigNumber.from(stack);
        let bignum = ((bignumx.mul(per)).div(100)).toString();
        setStakeValue(ethers.utils.formatEther(bignum));
        setPercentage(per);
    }
    const changePercentage = (val) => {
        let bignum = ((parseFloat(val) / (parseFloat(ethers.utils.formatEther(pool.user.tokenbalance))))) * 100;
        setPercentage(Math.ceil(bignum));
    }
    const onChangeStakeInput = (value) => {
       
        const validated = value.match(/^(\d*\.{0,1}\d{0,2}$)/);
        if (validated) {
            setStakeValue(value);
        }
    }

    return (
        <>
            <Modal
                open={open}
                onClose={onClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >

                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        p: 4,
                    }}>
                    <Box sx={{
                        width: 'auto',
                        // py: 4,
                        background: '#1A3342',
                        // boxShadow: 'rgba(14, 14, 44, 0.1) 0px 20px 36px -8px, rgba(0, 0, 0, 0.05) 0px 1px 1px',
                        borderRadius: '32px',
                        maxHeight: '100vh',
                        zIndex: '100',
                        minWidth: '346px'
                    }}>

                        <ModalHeader id="modal-modal-title">
                            <ModalHeaderText>
                                <Box
                                    sx={{
                                        fontSize: '20px',
                                        fontWeight: '600',
                                        lineHeight: '1.1',
                                        color: '#00FED9',
                                    }}>
                                    {/* {isRemovingStake ? ('Stake LP tokens') : ('Stake LP tokens')} */}
                                    {isRemovingStake ? ('Unstake') : ('Stake')}
                                    {/* Stake in pool */}
                                </Box>
                                <CloseIcon color="#00FED9" width="20px" height="20px" onClick={onClose} style={{ cursor: 'pointer' }} />
                            </ModalHeaderText>

                        </ModalHeader>

                        <ModalBody>


                            <Flex alignItems="center" justifyContent="space-between" mb="8px">
                                <Text color="white" bold>{isRemovingStake ? ('Unstake') : ('Stake')}:</Text>
                                <Flex alignItems="center" minWidth="70px" justifyContent="end">
                                    {/* <Image src={headerimage} width={24} height={24} alt={'symbol'} /> */}
                                    <Text ml="4px" bold color="white">
                                        DVX
                                    </Text>
                                </Flex>
                            </Flex>

                            <StyledBalanceInput>
                                <Flex justifyContent="right">
                                    <Box>
                                        <Flex alignItems="right">
                                            {/* <Text color="#B1B3CB" bold>Stake</Text> */}
                                            {/* <Text ml="auto" color="textSubtle" fontSize="12px" mb="8px">
                                                <Balance
                                                    fontSize="14px"
                                                    color="#B1B3CB"
                                                    textAlign="right"
                                                    decimals={3}
                                                    value={parseFloat(ethers.utils.formatEther(stack))}
                                                    unit=" "
                                                    prefix="Balance: "
                                                />
                                            </Text> */}
                                            <StyledInput

                                                inputMode="decimal"
                                                min={0}
                                                placeholder={'0.0'}
                                                value={stackvalue}
                                                onChange={(e) => { onChangeStakeInput(e.target.value); changePercentage(e.target.value ? e.target.value : '0') }}
                                            />

                                        </Flex>
                                        {/* <Flex alignItems="space-between"> */}
                                        {/* <StyledInput
                                                pattern={`^[0-9]*[.,]?[0-9]{0,${'18'}}$`}
                                                inputMode="decimal"
                                                min={0}
                                                placeholder={'0.0'}
                                                value={stackvalue}
                                                onChange={(e) => { setStakeValue(e.target.value); changePercentage(e.target.value ? e.target.value : '0') }}
                                            /> */}
                                        <Balance
                                            fontSize="12px"
                                            color="#B1B3CB"
                                            textAlign="right"
                                            decimals={2}
                                            value={usdvalue}
                                            unit=" USD"
                                            prefix="~"
                                        />
                                        {/* </Flex> */}
                                        {/* <Balance
                                            fontSize="12px"
                                            color="#B1B3CB"
                                            textAlign="right"
                                            decimals={2}
                                            value={usdvalue}
                                            unit=" USD"
                                            prefix="~"
                                        /> */}
                                    </Box>
                                    {/* <Flex alignItems="center" pl="12px">
                                            <SwitchUnitsButton scale="sm" variant="text" onClick={switchEditingUnits}>
                                                <SwapVertIcon color="textSubtle" />
                                            </SwitchUnitsButton>
                                        </Flex> */}
                                </Flex>
                            </StyledBalanceInput>
                            <Text ml="auto" color="textSubtle" fontSize="12px" mb="8px">
                                <Balance
                                    fontSize="14px"
                                    color="#B1B3CB"
                                    textAlign="right"
                                    decimals={3}
                                    value={parseFloat(ethers.utils.formatEther(stack))}
                                    unit=" "
                                    prefix="Balance: "
                                />
                            </Text>
                            <Slider sx={{ color: '#00FED9' }} defaultValue={0} value={percentage} onChange={(e, val) => { console.log(val); setPercentValue(val) }} aria-label="Default" valueLabelDisplay="on" />
                            <Flex alignItems="center" justifyContent="space-between" mt="8px">
                                <PercentageButton onClick={() => setPercentValue(25)}>25%</PercentageButton>
                                <PercentageButton onClick={() => setPercentValue(50)}>50%</PercentageButton>
                                <PercentageButton onClick={() => setPercentValue(75)}>75%</PercentageButton>
                                <PercentageButton onClick={() => setPercentValue(100)}>Max</PercentageButton>
                            </Flex>

                            {isRemovingStake ? (
                                <>

                                </>
                            ) : (
                                <Flex mt="24px" alignItems="center" justifyContent="space-between">
                                    <Text mr="8px" color="white">
                                        Annual ROI at current rates:
                                    </Text>
                                    <AnnualRoiContainer
                                        alignItems="center"
                                        onClick={() => {
                                            RoiCalculator()
                                        }}
                                    >
                                        <AnnualRoiDisplay color="white">{pool.apy}%</AnnualRoiDisplay>
                                        <IconButton variant="text" scale="sm">
                                            <CalculateIcon color="#00FED9" width="18px" />
                                        </IconButton>
                                    </AnnualRoiContainer>


                                </Flex>
                            )}

                            <ConfirmButton sx={{ mt: 3 }} onClick={() => { isRemovingStake ? unStackDVX() : depositDVX() }} disabled={disabledbutton || parseFloat(stackvalue) <= 0 || stackvalue == "" || parseFloat(stackvalue) > parseFloat(ethers.utils.formatEther(stack))}  >
                                Confirm {disabledbutton && <Box><LoopIcon className="animation-spin" sx={{ width: '18px', height: '18px' }} /></Box>}
                            </ConfirmButton>

                            {isRemovingStake ? (
                                <>
                                </>
                            ) : (
                                <StyledLink external>
                                    <GetSymbol>
                                        Get DVX
                                    </GetSymbol>
                                </StyledLink>
                            )}

                        </ModalBody>
                    </Box>
                </Box>
            </Modal>
            <RoiCalculatorModal open={RoiCalculatoropen} onClose={handleClose} pool={pool} stackvalue={stackvalue} usdvalue={usdvalue}></RoiCalculatorModal>
        </>
    );
};

export default StakeModal;
